import React, { useState } from 'react'
import { Link as RouterLink } from 'react-router-dom'
import { Menu as MenuIcon } from '@mui/icons-material'
import {
  AppBar,
  Box,
  IconButton,
  SwipeableDrawer,
  Toolbar
} from '@mui/material'
import orbitCondensed from 'assets/brand/orbit/orbitCondensed.svg'
import OrbitSession from 'hooks/useCookies'

import ProfileMenu from '../Web/NavbarProfileMenu'

import MobileMenu from './MobileMenu'

const MobileAppBar = () => {
  const role = OrbitSession.get('role')
  const [drawer, toggleDrawer] = useState(false)

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar
        position='static'
        sx={{
          boxShadow: '0px 5px 15px rgba(0, 0, 0, 0.35)',
          zIndex: '1',
          backgroundColor: ['owner', 'admin', 'demo'].includes(role)
            ? '#818D9C'
            : '#000869'
        }}
      >
        <Toolbar>
          <IconButton
            size='large'
            edge='start'
            color='inherit'
            aria-label='open drawer'
            sx={{ mr: 2 }}
            onClick={() => toggleDrawer(true)}
          >
            <MenuIcon />
          </IconButton>

          <Box
            component={RouterLink}
            to='/'
            sx={{
              width: '20px',
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <img src={orbitCondensed} />
          </Box>

          <Box sx={{ flexGrow: 1 }} />

          <Box sx={{ display: 'flex' }}>
            {/* <IconButton
              size='large'
              aria-label='show 17 new notifications'
              color='inherit'
            >
              <Badge badgeContent={17} color='error'>
                <NotificationsIcon />
              </Badge>
            </IconButton> */}

            <ProfileMenu toggled={false} />
          </Box>
        </Toolbar>
      </AppBar>
      <SwipeableDrawer
        anchor='left'
        open={drawer}
        onClose={() => toggleDrawer(false)}
        onOpen={() => toggleDrawer(true)}
        sx={{ top: '200px' }}
      >
        <Box
          width='80vw'
          height='100vh'
          sx={{
            backgroundColor: '#404040',
            color: 'white'
          }}
        >
          <MobileMenu role={role} toggleDrawer={toggleDrawer} />
        </Box>
      </SwipeableDrawer>
    </Box>
  )
}

export default MobileAppBar
